import { LocationType } from "../store/slices/mapsSlice";

export function getOverlayLocation(overlay: any) {
  let coordinates: any;
  if (overlay instanceof google.maps.Marker) {
    coordinates = [overlay.getPosition()?.lng(), overlay.getPosition()?.lat()];

    return {
      Point: {
        type: "Point",
        coordinates,
      },
      // Uuid: (overlay as any).locationData?.Uuid || "",
      IsCurrent: false,
      IsShape: false,
      Description: (overlay as any).formatted_address || "",
    };
  } else if (!!overlay.position) {
    coordinates = [overlay.position?.lng, overlay.position?.lat];

    return {
      Point: {
        type: "Point",
        coordinates,
      },
      // Uuid: (overlay as any).locationData?.Uuid || "",
      IsCurrent: false,
      IsShape: false,
    };
  } else if (!!overlay.getRadius && !!overlay.getCenter) {
    coordinates = [overlay.getCenter()?.lng(), overlay.getCenter()?.lat()];

    return {
      Circle: {
        type: "Circle",
        coordinates,
      },
      // Uuid: (overlay as any).locationData?.Uuid || "",
      IsCurrent: false,
      IsShape: false,
    };
  } else if (overlay instanceof google.maps.Polygon) {
    coordinates = overlay
      .getPath()
      .getArray()
      .map((latLng: any) => {
        return [latLng.lng(), latLng.lat()];
      });
    coordinates.push(coordinates[0]);
  } else if (overlay instanceof google.maps.Rectangle) {
    const bounds: any = overlay.getBounds();
    coordinates = [
      [bounds.getNorthEast().lng(), bounds.getNorthEast().lat()],
      [bounds.getSouthWest().lng(), bounds.getNorthEast().lat()],
      [bounds.getSouthWest().lng(), bounds.getSouthWest().lat()],
      [bounds.getNorthEast().lng(), bounds.getSouthWest().lat()],
      [bounds.getNorthEast().lng(), bounds.getNorthEast().lat()],
    ];
  }

  return {
    IsShape: true,
    Area: {
      type: "MultiPolygon",
      coordinates: [[coordinates]],
    },
    // Uuid: (overlay as any).locationData?.Uuid || "",
    IsCurrent: false,
  };
}

export function addLocationsToMap({
  locations,
  map,
}: {
  locations: LocationType[] | undefined;
  map: google.maps.Map;
}) {
  const locationOverlays: any[] = [];

  if (!map) return;

  locations?.forEach((location) => {
    let overlay: any;
    if (location.IsShape) {
      overlay = new google.maps.Polygon({
        paths: location.Area?.coordinates[0][0].map(([lng, lat]) => ({
          lat,
          lng,
        })),
        draggable: true,
        editable: true,
      });
    } else {
      overlay = new google.maps.Marker({
        position: {
          lat: location.Point?.coordinates[1] ?? 0,
          lng: location.Point?.coordinates[0] ?? 0,
        },
        draggable: true,
      });
    }
    (overlay as any).locationData = location;
    overlay.setMap(map);
    locationOverlays.push(overlay);
  });

  return locationOverlays;
}

export function convertMapBoundsToGeoJson(map: google.maps.Map) {
  const coordinates = map.getBounds()?.toJSON();
  let center = (map.getCenter()?.lng() || 0) % 360; // Normalize the center longitude to be between -180 and 180
  if (center > 180) center -= 360;
  if (center < -180) center += 360;
  let east = coordinates?.east || 0;
  let west = coordinates?.west || 0;
  if (east === 180 && west === -180) {
    center = 0;
  }
  if (east === 180) east = 179.9999;
  if (west === -180) west = -179.9999;

  return [
    [west, coordinates?.north],
    [west, coordinates?.south],
    [center, coordinates?.south],
    [east, coordinates?.south],
    [east, coordinates?.north],
    [center, coordinates?.north],
    [west, coordinates?.north],
  ];
}

export function toCamel(o: any) {
  if (o === null || o === undefined) {
    return o;
  }
  var newO, origKey, newKey, value;
  if (o instanceof Array) {
    return o.map(function (value) {
      if (typeof value === "object") {
        value = toCamel(value);
      }
      return value;
    });
  } else {
    newO = {} as { [key: string]: any };
    for (origKey in o) {
      if (o.hasOwnProperty(origKey)) {
        newKey = origKey.replace(/_./g, (x: any) => x[1].toUpperCase());
        value = o[origKey];
        if (
          value instanceof Array ||
          (value !== null && value.constructor === Object)
        ) {
          value = toCamel(value);
        }
        newO[newKey] = value;
      }
    }
  }
  return newO;
}
